<template>
  <div class="versionlist">
    <div style="width: 100%">
        <el-row>
          <el-col :span='4'>
            <el-button type='primary' @click='modalVisible = true; modalType = "add"; newest = false'><i class="el-icon-plus"></i> 发布版本</el-button>
          </el-col>
          <el-col :span="10" :offset='10'>
            <el-form @submit.native.prevent label-width='100px'>
              <el-form-item label='关键字检索:'>
                <el-input v-model="cdit" placeholder='版本号、版本名称、版本描述' size='mini' style='width: 80%' @keyup.enter.native='currentPage = 1; getVersionlist()' clearable @clear='currentPage = 1; getVersionlist()'>
                  <el-button slot="append" icon="el-icon-search" @click="currentPage = 1; getVersionlist()"></el-button>
                </el-input>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
    </div>

    <!-- 版本列表 -->
    <div class="flex-row-between">
      <h3 width='100px'>版本列表</h3>
      <div>当前 {{total > 0 ? (pageStart + 1) : 0}} - {{pageEnd > total ? total : pageEnd}} 项, 共 {{total}} 项</div>
    </div>
    <el-table
      :data='versionlist'
      stripe
      style='width: 100%'
      border
      header-cell-class-name='myth'
      cell-class-name='mytd'
      v-loading="loading"
      size='small'
    >
      <el-table-column
        type="index"
        width="70"
        :index='indexMethod'
      />
      <el-table-column prop='version_code' label='版本号'/>
      <el-table-column prop='version_name' label='版本名称'/>
      <el-table-column prop='version_desc' label='版本描述'/>
      <el-table-column
        label='是否最高版本'
        width='120'
      >
        <template slot-scope='scope'>
          {{scope.row.version_is_newest ? '是' : '否'}}
        </template>
      </el-table-column>
      <el-table-column prop='create_dt' label='发布时间'/>
      <el-table-column
        label='是否已上传APK'
        width='130'
      >
        <template slot-scope='scope'>
          {{scope.row.store_path ? '是' : '否'}}
        </template>
      </el-table-column>
      <el-table-column prop='store_path' label='下载地址'/>
      <el-table-column
        label='操作'
        width='180'
      >
        <template slot-scope='scope'>
          <el-button type='primary' size='mini' @click='handleSet(scope.row)'>修改</el-button>
          <el-button @click='handleRemove(scope.row)' slot='reference' type='danger' size='mini'>删除</el-button>
        </template>
      </el-table-column>
      <el-table-column
        label='上传apk'
        width='160'
      >
        <template slot-scope='scope'>
          <el-upload
            :multiple='false'
            name='apk'
            action="/box/App/uploadPackage"
            :on-success='onUploadSucces'
            :on-error='onUploadFail'
            :data='{
              id: scope.row.id
            }'
            :file-list="filelist"
            :show-file-list='false'
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页器 -->
    <div class="flex-row-end" style="margin-top: 16px;">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="pageSize"
        v-if="total > pageSize"
        @current-change="onPageChange"
        :current-page.sync='currentPage'
      >
      </el-pagination>
    </div>
    

    <!-- 模态窗 -->
    <el-dialog
      :title="modalType == 'add' ? '发布版本' : '修改版本'"
      :visible.sync="modalVisible"
      width='600px'
      :before-close="handleClose"
    >
      <el-form @submit.native.prevent ref='version-form' :model="form" label-width='120px' :rules="rules">
        <el-form-item label='版本号' prop='version_code'>
          <el-input v-model="form.version_code" placeholder='请输入版本号'/>
        </el-form-item>
        <el-form-item label='版本名称' prop='version_name'>
          <el-input v-model="form.version_name" placeholder='请输入版本名称'/>
        </el-form-item>
        <el-form-item label='版本描述' prop='version_desc'>
          <el-input v-model="form.version_desc" placeholder='请输入版本描述'/>
        </el-form-item>
        <el-form-item label='是否最高版本' prop='version_is_newest'>
          {{form.version_is_newes}}
          <el-radio-group v-model="form.version_is_newest" style="width: 360px" :disabled='newest' @change='onNewestChange'>
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="handleOk">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import { mapState } from 'vuex'
  import { post } from '@/utils/http'

  export default {
    data() {
      return {
        versionlist: [],
        total: 0,
        pageStart: 0,
        pageEnd: 0,
        currentPage: 1,
        pageSize: 10,
        form: {},
        modalVisible: false,
        modalType: '',
        loading: false,
        filelist: [],
        rules: {
          version_code: [
            { required: true, message: '请输入版本号', trigger: 'blur' }
          ],
          version_name: [
            { required: true, message: '请输入版本名称', trigger: 'blur' }
          ],
          version_desc: [
            { required: true, message: '请输入版本描述', trigger: 'blur' }
          ],
          version_is_newest: [
            { required: true, message: '请选择是否最高版本', trigger: 'blur' }
          ]
        },
        cdit: '',
        newest: false
      }
    },
    computed: {
      ...mapState(['user_id'])
    },
    mounted() {
      this.getVersionlist()
    },
    methods: {
      async getVersionlist() {
        this.loading = true
        const data = {
          page_ix: this.currentPage,
          page_size: this.pageSize
        }
        if (this.cdit) {
          data.cdit = this.cdit
        }
        try {
          const res = await post('/box/App/queryVersion', data)
          this.loading = false
          if (res && res.rst == 0) {
            this.versionlist = res.data.data
            this.total = res.data.total
            this.pageStart = (res.data.current_page - 1) * this.pageSize
            this.pageEnd = this.pageStart + this.pageSize
          }
        } catch(err) {
          this.loading = false
        }
      },
      handleSet(unit) {
        console.log(unit)
        if (unit.version_is_newest) {
          this.newest = true
        } else {
          this.newest = false
        }
        this.form = { ...unit }
        this.modalVisible = true
        this.modalType = 'set'
      },
      async handleOk() {
        this.$refs['version-form'].validate(async (valid) => {
          if (valid) {
            switch (this.modalType) {
              case 'add':
                try {
                  const res1 = await post('/box/App/addVersion', this.form)
                  if (res1 && res1.rst == 0) {
                    this.$message({
                      message: '发布成功',
                      type: 'success'
                    })
                    this.handleClose()
                    this.getVersionlist()
                    break
                  }
                  this.$message.error(res1.msg || '发布失败')
                  break
                } catch(err) {
                  this.$message.error('发布失败')
                  break
                }
              case 'set':
                try {
                  const res2 = await post('/box/App/setVersion', this.form)
                  if (res2 && res2.rst == 0) {
                    this.$message({
                      message: '修改成功',
                      type: 'success'
                    })
                    this.handleClose()
                    this.getVersionlist()
                    break
                  }
                  this.$message.error(res2.msg || '修改失败')
                  break
                } catch(err) {
                  this.$message.error('修改失败')
                  break
                } 
            }
          } else {
            return false;
          }
        });
      },
      onNewestChange(val) {
        if (val == 1) {
          this.$alert('设置为最高版本将替换掉原有的最高版本', '注意', {
            confirmButtonText: '确定'
          })
        }
      },
      handleRemove(ver) {
        this.$confirm('确定要删除版本 ' + ver.version_code + ' 吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          try {
            const res = await post('/box/App/removeVersion', {
              id: ver.id
            })
            if (res && res.rst == 0) {
              this.$message({
                message: '删除成功',
                type: 'success'
              })
              this.getVersionlist()
            }
          } catch(err) {
            this.$message({
              type: 'info',
              message: '删除失败请重试'
            }); 
          }
        });
      },
      handleClose() {
        this.modalVisible = false
        setTimeout(() => {
          this.modalType = ''
          this.resetForm()
          this.form = {}
        }, 200);
      },
      onUploadSucces(response, file, fileList) {
        if (response.rst != 0) {
          this.$message.error(response.msg || '上传失败')
          return
        }
        this.$message({
          message: '上传成功',
          type: 'success'
        })
        this.getVersionlist()
        this.filelist = []
        console.log(response, 'file', file, 'fileList', fileList)
      },
      onUploadFail(err, file, fileList) {
        this.$message.error('上传失败')
        console.log(err, 'file', file, 'fileList', fileList)
      },
      onPageChange(page) {
        this.currentPage = page
        this.getVersionlist()
      },
      resetForm() {
        this.$refs['version-form'].resetFields();
      },
      indexMethod(index) {
        return index + this.pageStart + 1;
      }
    },
    name: 'version'
  }
</script>
<style lang="less" scoped>

</style>
